/* oxlint-disable max-lines */
const baseColors = {
  white: '#ffffff',
  black: '#000000',
  brand: {
    light: {
      1: '#f2f6f5',
      2: '#e6edeb',
      3: '#ccdcd7',
      4: '#b3cac2',
      5: '#99b9ae',
      6: '#80a79a',
      7: '#4d8472',
      8: '#33725d',
      9: '#01654C',
      10: '#003f2a',
      11: '#00281b',
      12: '#001810',
    },
    dark: {
      1: '#121b15',
      2: '#142118',
      3: '#14311e',
      4: '#103f24',
      5: '#104c2a',
      6: '#105b32',
      7: '#106c3b',
      8: '#068045',
      9: '#18ff90',
      10: '#00f486',
      11: '#00ef81',
      12: '#acfec5',
    },
  },
  brandSlate: {
    light: '#454341',
    dark: '#e9e6e2',
  },
  neutrals: {
    light: {
      1: '#fdfdfc',
      2: '#f6f6f6',
      3: '#f1f0ef',
      4: '#e9e8e6',
      5: '#e2e1de',
      6: '#dad9d6',
      7: '#cfceca',
      8: '#bcbbb5',
      9: '#8d8d86',
      10: '#82827c',
      11: '#63635e',
      12: '#21201c',
    },
    dark: {
      1: '#111110',
      2: '#191918',
      3: '#222221',
      4: '#2a2a28',
      5: '#31312e',
      6: '#3b3a37',
      7: '#494844',
      8: '#62605b',
      9: '#6f6d66',
      10: '#7c7b74',
      11: '#b5b3ad',
      12: '#eeeeec',
    },
  },
  semantic: {
    danger: {
      light: {
        1: '#fffcfc',
        2: '#fff7f7',
        3: '#feebec',
        4: '#ffdbdc',
        5: '#ffcdce',
        6: '#fdbdbe',
        7: '#f4a9aa',
        8: '#eb8e90',
        9: '#e5484d',
        10: '#dc3e42',
        11: '#ce2c31',
        12: '#641723',
      },
      dark: {
        1: '#191111',
        2: '#201314',
        3: '#3b1219',
        4: '#500f1c',
        5: '#611623',
        6: '#72232d',
        7: '#8c333a',
        8: '#b54548',
        9: '#e5484d',
        10: '#ec5d5e',
        11: '#ff9592',
        12: '#ffd1d9',
      },
    },
    info: {
      light: {
        1: '#fbfdff',
        2: '#f4faff',
        3: '#e6f4fe',
        4: '#d5efff',
        5: '#c2e5ff',
        6: '#acd8fc',
        7: '#8ec8f6',
        8: '#5eb1ef',
        9: '#0090ff',
        10: '#0588f0',
        11: '#0d74ce',
        12: '#113264',
      },
      dark: {
        1: '#0d1520',
        2: '#111927',
        3: '#0d2847',
        4: '#003362',
        5: '#004074',
        6: '#104d87',
        7: '#205d9e',
        8: '#2870bd',
        9: '#0090ff',
        10: '#3b9eff',
        11: '#70b8ff',
        12: '#c2e6ff',
      },
    },
    success: {
      light: {
        1: '#fbfefc',
        2: '#f4fbf6',
        3: '#e6f6eb',
        4: '#d6f1df',
        5: '#c4e8d1',
        6: '#adddc0',
        7: '#8eceaa',
        8: '#5bb98b',
        9: '#30a46c',
        10: '#2b9a66',
        11: '#218358',
        12: '#193b2d',
      },
      dark: {
        1: '#0e1512',
        2: '#121b17',
        3: '#132d21',
        4: '#113b29',
        5: '#174933',
        6: '#20573e',
        7: '#28684a',
        8: '#2f7c57',
        9: '#30a46c',
        10: '#33b074',
        11: '#3dd68c',
        12: '#b1f1cb',
      },
    },
    warning: {
      light: {
        1: '#fefdfb',
        2: '#fefbe9',
        3: '#fff7c2',
        4: '#ffee9c',
        5: '#fbe577',
        6: '#f3d673',
        7: '#e9c162',
        8: '#e2a336',
        9: '#ffc53d',
        10: '#ffba18',
        11: '#ab6400',
        12: '#4f3422',
      },
      dark: {
        1: '#16120c',
        2: '#1d180f',
        3: '#302008',
        4: '#3f2700',
        5: '#4d3000',
        6: '#5c3d05',
        7: '#714f19',
        8: '#8f6424',
        9: '#ffc53d',
        10: '#ffd60a',
        11: '#ffca16',
        12: '#ffe7b3',
      },
    },
  },
  utility: {
    bronze: {
      light: { 3: '#f6edea', 4: '#efe4df', 6: '#dfcdc5', 9: '#a18072', 12: '#43302b' },
      dark: { 3: '#262220', 4: '#302a27', 6: '#493e3a', 9: '#a18072', 12: '#ede0d9' },
    },
    gold: {
      light: { 3: '#f2f0e7', 4: '#eae6db', 6: '#d8d0bf', 9: '#978365', 12: '#3b352b' },
      dark: { 3: '#24231f', 4: '#2d2b26', 6: '#444039', 9: '#978365', 12: '#e8e2d9' },
    },
    plum: {
      light: { 3: '#fbebfb', 4: '#f7def8', 6: '#e9c2ec', 9: '#ab4aba', 11: '#953ea3', 12: '#53195d' },
      dark: { 3: '#351a35', 4: '#451D47', 6: '#5e3061', 9: '#ab4aba', 11: '#e796f3', 12: '#f4d4f4' },
    },
    iris: {
      light: { 3: '#f0f1fe', 4: '#e6e7ff', 6: '#cbcdff', 9: '#5b5bd6', 11: '#5753c6', 12: '#272962' },
      dark: { 3: '#202248', 4: '#262a65', 6: '#3d3e82', 9: '#5b5bd6', 11: '#b1a9ff', 12: '#e0dffe' },
    },
    pink: {
      light: { 3: '#fee9f5', 4: '#fbdcef', 6: '#efbfdd', 9: '#d6409f', 12: '#651249' },
      dark: { 3: '#37172f', 4: '#4b143d', 6: '#692955', 9: '#d6409f', 12: '#fdd1ea' },
    },
    orange: {
      light: { 3: '#ffefd6', 4: '#ffdfb5', 6: '#ffc182', 9: '#f76b15', 12: '#582d1d' },
      dark: { 3: '#331e0b', 4: '#462100', 6: '#66350c', 9: '#f76b15', 12: '#ffe0c2' },
    },
    lime: {
      light: { 3: '#eef6d6', 4: '#e2f0bd', 6: '#c2da91', 9: '#bdee63', 12: '#37401c' },
      dark: { 3: '#1f2917', 4: '#29371d', 6: '#3d522a', 9: '#bdee63', 12: '#e3f7ba' },
    },
    mint: {
      light: { 3: '#ddf9f2', 4: '#c8f4e9', 6: '#9ce0d0', 9: '#86ead4', 12: '#16433c' },
      dark: { 3: '#092c2b', 4: '#003a38', 6: '#105650', 9: '#86ead4', 12: '#c4f5e1' },
    },
  },
  // Chart series colours. `default` is the hue at 80% alpha (`cc`) and `hover` the same hue
  // opaque, so a hovered series reads as stronger than its neighbours without changing hue.
  // These are a separate set from `utility` — do not substitute one for the other.
  dataViz: {
    light: {
      brand: { default: '#004f35cc', hover: '#004f35' },
      blue: { default: '#2e9bffcc', hover: '#2e9bff' },
      iris: { default: '#6e6fd6cc', hover: '#6e6fd6' },
      crimson: { default: '#e8588ecc', hover: '#e8588e' },
      fuchsia: { default: '#c44fc9cc', hover: '#c44fc9' },
      coral: { default: '#e0644bcc', hover: '#e0644b' },
      peach: { default: '#f0a06acc', hover: '#f0a06a' },
      orange: { default: '#e8731ccc', hover: '#e8731c' },
      mint: { default: '#6fd3a3cc', hover: '#6fd3a3' },
      teal: { default: '#3d96aecc', hover: '#3d96ae' },
      sky: { default: '#74c7f5cc', hover: '#74c7f5' },
      plum: { default: '#9e5273cc', hover: '#9e5273' },
      yellow: { default: '#e0a21ccc', hover: '#e0a21c' },
      red: { default: '#d33a3fcc', hover: '#d33a3f' },
    },
    dark: {
      brand: { default: '#18ff90cc', hover: '#18ff90' },
      blue: { default: '#57abffcc', hover: '#57abff' },
      iris: { default: '#8a8be6cc', hover: '#8a8be6' },
      crimson: { default: '#ed7aa4cc', hover: '#ed7aa4' },
      fuchsia: { default: '#d274d6cc', hover: '#d274d6' },
      coral: { default: '#eb8068cc', hover: '#eb8068' },
      peach: { default: '#f4b488cc', hover: '#f4b488' },
      orange: { default: '#f28e33cc', hover: '#f28e33' },
      mint: { default: '#8ae0bacc', hover: '#8ae0ba' },
      teal: { default: '#54aec6cc', hover: '#54aec6' },
      sky: { default: '#93d6f8cc', hover: '#93d6f8' },
      plum: { default: '#b8728fcc', hover: '#b8728f' },
      yellow: { default: '#ffc53dcc', hover: '#ffc53d' },
      red: { default: '#f26468cc', hover: '#f26468' },
    },
  },
  transparent: {
    white: {
      0: '#ffffff00',
      2: '#ffffff05',
      4: '#ffffff0a',
      6: '#ffffff0f',
      8: '#ffffff14',
      16: '#ffffff29',
      24: '#ffffff3d',
      32: '#ffffff52',
      48: '#ffffff7a',
      64: '#ffffffa3',
      80: '#ffffffcc',
      96: '#fffffff5',
    },
    black: {
      0: '#00000000',
      2: '#00000005',
      4: '#0000000a',
      6: '#0000000f',
      8: '#00000014',
      16: '#00000029',
      24: '#0000003d',
      32: '#00000052',
      48: '#0000007a',
      64: '#000000a3',
      80: '#000000cc',
      96: '#000000f5',
    },
  },
} as const

export const lightPalette = {
  bg: {
    surface: {
      default: baseColors.white,
      subtle: baseColors.neutrals.light[2],
      elevated: baseColors.white,
      inset: baseColors.transparent.black[6],
      glass: baseColors.transparent.white[32],
    },
    overlay: baseColors.transparent.black[32],
    invisible: baseColors.transparent.white[0],
    inverted: baseColors.neutrals.dark[1],
    interactive: {
      hover: baseColors.transparent.black[6],
      active: baseColors.transparent.black[8],
    },
    brand: {
      default: baseColors.brand.light[9],
      hover: baseColors.brand.light[10],
      muted: baseColors.brand.light[2],
      mutedHover: baseColors.brand.light[3],
    },
    neutral: {
      default: baseColors.neutrals.light[8],
      hover: baseColors.neutrals.light[10],
      muted: baseColors.neutrals.light[4],
      mutedHover: baseColors.neutrals.light[5],
      strong: baseColors.neutrals.light[11],
    },
    success: {
      default: baseColors.semantic.success.light[9],
      hover: baseColors.semantic.success.light[11],
      muted: baseColors.semantic.success.light[3],
      mutedHover: baseColors.semantic.success.light[4],
    },
    danger: {
      default: baseColors.semantic.danger.light[9],
      hover: baseColors.semantic.danger.light[11],
      muted: baseColors.semantic.danger.light[3],
      mutedHover: baseColors.semantic.danger.light[4],
    },
    warning: {
      default: baseColors.semantic.warning.light[9],
      hover: baseColors.semantic.warning.light[11],
      muted: baseColors.semantic.warning.light[3],
      mutedHover: baseColors.semantic.warning.light[4],
    },
    info: {
      default: baseColors.semantic.info.light[9],
      hover: baseColors.semantic.info.light[11],
      muted: baseColors.semantic.info.light[3],
      mutedHover: baseColors.semantic.info.light[4],
    },
    ai: {
      default: baseColors.utility.iris.light[9],
      muted: baseColors.utility.iris.light[3],
      mutedHover: baseColors.utility.iris.light[4],
      strongest: baseColors.utility.iris.light[11],
    },
    utility: {
      bronze: {
        default: baseColors.utility.bronze.light[9],
        muted: baseColors.utility.bronze.light[3],
        mutedHover: baseColors.utility.bronze.light[4],
      },
      gold: {
        default: baseColors.utility.gold.light[9],
        muted: baseColors.utility.gold.light[3],
        mutedHover: baseColors.utility.gold.light[4],
      },
      plum: {
        default: baseColors.utility.plum.light[9],
        muted: baseColors.utility.plum.light[3],
        mutedHover: baseColors.utility.plum.light[4],
      },
      pink: {
        default: baseColors.utility.pink.light[9],
        muted: baseColors.utility.pink.light[3],
        mutedHover: baseColors.utility.pink.light[4],
      },
      orange: {
        default: baseColors.utility.orange.light[9],
        muted: baseColors.utility.orange.light[3],
        mutedHover: baseColors.utility.orange.light[4],
      },
      lime: {
        default: baseColors.utility.lime.light[9],
        muted: baseColors.utility.lime.light[3],
        mutedHover: baseColors.utility.lime.light[4],
      },
      mint: {
        default: baseColors.utility.mint.light[9],
        muted: baseColors.utility.mint.light[3],
        mutedHover: baseColors.utility.mint.light[4],
      },
      iris: {
        default: baseColors.utility.iris.light[9],
        muted: baseColors.utility.iris.light[3],
        mutedHover: baseColors.utility.iris.light[4],
      },
    },
  },
  fg: {
    default: baseColors.neutrals.light[12],
    muted: baseColors.neutrals.light[11],
    subtle: baseColors.neutrals.light[9],
    inverted: baseColors.white,
    elevated: baseColors.white,
    brand: {
      default: baseColors.brand.light[9],
      onBrand: baseColors.white,
      onBrandMuted: baseColors.brand.light[11],
    },
    danger: {
      default: baseColors.semantic.danger.light[9],
      onDanger: baseColors.white,
      onDangerMuted: baseColors.semantic.danger.light[11],
    },
    warning: {
      default: baseColors.semantic.warning.light[11],
      onWarning: baseColors.semantic.warning.light[12],
      onWarningMuted: baseColors.semantic.warning.light[12],
    },
    success: {
      default: baseColors.semantic.success.light[9],
      onSuccess: baseColors.white,
      onSuccessMuted: baseColors.semantic.success.light[11],
    },
    info: {
      default: baseColors.semantic.info.light[9],
      onInfo: baseColors.white,
      onInfoMuted: baseColors.semantic.info.light[11],
    },
    ai: {
      default: baseColors.utility.iris.light[9],
      strongest: baseColors.utility.iris.light[11],
    },
    utility: {
      bronze: { default: baseColors.utility.bronze.light[9] },
      gold: { default: baseColors.utility.gold.light[9] },
      plum: { default: baseColors.utility.plum.light[9], 'on-plum-muted': baseColors.utility.plum.light[12] },
      pink: { default: baseColors.utility.pink.light[12] },
      orange: { default: baseColors.utility.orange.light[9] },
      lime: { default: baseColors.utility.lime.light[12] },
      mint: { default: baseColors.utility.mint.light[12] },
    },
  },
  text: {
    default: baseColors.neutrals.light[12],
    muted: baseColors.neutrals.light[11],
    subtle: baseColors.neutrals.light[9],
    inverted: baseColors.white,
    link: baseColors.semantic.info.light[11],
    slate: baseColors.brandSlate.light,
    brand: {
      default: baseColors.brand.light[9],
      onBrand: baseColors.white,
      onBrandMuted: baseColors.brand.light[12],
    },
    success: {
      default: baseColors.semantic.success.light[11],
      onSuccess: baseColors.white,
      onSuccessMuted: baseColors.semantic.success.light[12],
    },
    danger: {
      default: baseColors.semantic.danger.light[11],
      onDanger: baseColors.white,
      onDangerMuted: baseColors.semantic.danger.light[11],
    },
    warning: {
      default: baseColors.semantic.warning.light[11],
      onWarning: baseColors.semantic.warning.light[12],
      onWarningMuted: baseColors.semantic.warning.light[12],
    },
    info: {
      default: baseColors.semantic.info.light[11],
      onInfo: baseColors.white,
      onInfoMuted: baseColors.semantic.info.light[12],
    },
    ai: {
      default: baseColors.utility.iris.light[11],
      onAi: baseColors.white,
    },
    utility: {
      bronze: { default: baseColors.utility.bronze.light[12], 'on-bronze': baseColors.white },
      gold: { default: baseColors.utility.gold.light[12], 'on-gold': baseColors.white },
      plum: { default: baseColors.utility.plum.light[12], 'on-plum': baseColors.white },
      pink: { default: baseColors.utility.pink.light[12], 'on-pink': baseColors.white },
      orange: { default: baseColors.utility.orange.light[12], 'on-orange': baseColors.white },
      lime: { default: baseColors.utility.lime.light[12], 'on-lime': baseColors.utility.lime.light[12] },
      mint: { default: baseColors.utility.mint.light[12], 'on-mint': baseColors.utility.mint.light[12] },
    },
  },
  border: {
    subtle: baseColors.neutrals.light[5],
    glass: baseColors.transparent.black[4],
    strong: baseColors.neutrals.light[7],
    strongest: baseColors.neutrals.light[10],
    focus: baseColors.semantic.info.light[9],
    white: baseColors.white,
    inverted: baseColors.neutrals.dark[1],
    transparent: baseColors.transparent.white[48],
    transparent_inverted: baseColors.transparent.black[48],
    brand: {
      subtle: baseColors.brand.light[6],
      strong: baseColors.brand.light[9],
      strongest: baseColors.brand.light[11],
    },
    success: {
      strong: baseColors.semantic.success.light[9],
      focus: baseColors.semantic.success.light[7],
      subtle: baseColors.semantic.success.light[6],
      strongest: baseColors.semantic.success.light[11],
    },
    danger: {
      strong: baseColors.semantic.danger.light[9],
      focus: baseColors.semantic.danger.light[7],
      subtle: baseColors.semantic.danger.light[6],
      strongest: baseColors.semantic.danger.light[11],
    },
    warning: {
      strong: baseColors.semantic.warning.light[9],
      focus: baseColors.semantic.warning.light[7],
      subtle: baseColors.semantic.warning.light[6],
    },
    info: {
      strong: baseColors.semantic.info.light[9],
      focus: baseColors.semantic.info.light[7],
      subtle: baseColors.semantic.info.light[6],
      strongest: baseColors.semantic.info.light[11],
    },
    ai: {
      subtle: baseColors.utility.iris.light[6],
      strong: baseColors.utility.iris.light[9],
      strongest: baseColors.utility.iris.light[12],
    },
    utility: {
      bronze: { muted: baseColors.utility.bronze.light[6], strong: baseColors.utility.bronze.light[9] },
      gold: { muted: baseColors.utility.gold.light[6], strong: baseColors.utility.gold.light[9] },
      plum: {
        muted: baseColors.utility.plum.light[6],
        strong: baseColors.utility.plum.light[9],
        strongest: baseColors.utility.plum.light[12],
      },
      pink: { muted: baseColors.utility.pink.light[6], strong: baseColors.utility.pink.light[9] },
      orange: { muted: baseColors.utility.orange.light[6], strong: baseColors.utility.orange.light[9] },
      lime: { muted: baseColors.utility.lime.light[6], strong: baseColors.utility.lime.light[9] },
      mint: { muted: baseColors.utility.mint.light[6], strong: baseColors.utility.mint.light[9] },
      iris: { muted: baseColors.utility.iris.light[6], strong: baseColors.utility.iris.light[9] },
    },
  },
  effects: {
    'active-focus': baseColors.transparent.black[8],
    'active-ai': baseColors.utility.iris.light[4],
    'active-error': baseColors.semantic.danger.light[4],
    'active-success': baseColors.semantic.success.light[4],
    'active-brand': baseColors.brand.light[2],
    'button-inner': baseColors.transparent.white[80],
    glass: baseColors.transparent.white[64],
    'button-drop': baseColors.transparent.black[4],
  },
  shadows: {
    xs: { 1: 'rgba(0, 0, 0, 0.06)' },
    sm: { 1: 'rgba(0, 0, 0, 0.08)', 2: 'rgba(0, 0, 0, 0.08)' },
    md: { 1: 'rgba(0, 0, 0, 0.1)', 2: 'rgba(0, 0, 0, 0.1)' },
    lg: { 1: 'rgba(0, 0, 0, 0.1)', 2: 'rgba(0, 0, 0, 0.1)' },
    xl: { 1: 'rgba(0, 0, 0, 0.14)', 2: 'rgba(0, 0, 0, 0.12)' },
  },
  dataViz: baseColors.dataViz.light,
} as const

export const darkPalette = {
  bg: {
    surface: {
      default: baseColors.neutrals.dark[3],
      subtle: baseColors.neutrals.dark[2],
      elevated: baseColors.neutrals.dark[5],
      inset: baseColors.transparent.black[48],
      glass: baseColors.transparent.white[8],
    },
    overlay: baseColors.transparent.black[64],
    invisible: baseColors.transparent.black[0],
    inverted: baseColors.white,
    interactive: {
      hover: baseColors.transparent.white[8],
      active: baseColors.transparent.white[16],
    },
    brand: {
      default: baseColors.brand.dark[9],
      hover: baseColors.brand.dark[10],
      muted: baseColors.brand.dark[3],
      mutedHover: baseColors.brand.dark[5],
    },
    neutral: {
      default: baseColors.neutrals.dark[8],
      hover: baseColors.neutrals.dark[10],
      muted: baseColors.neutrals.dark[6],
      mutedHover: baseColors.neutrals.dark[7],
      strong: baseColors.neutrals.dark[11],
    },
    success: {
      default: baseColors.semantic.success.dark[9],
      hover: baseColors.semantic.success.dark[11],
      muted: baseColors.semantic.success.dark[4],
      mutedHover: baseColors.semantic.success.dark[5],
    },
    danger: {
      default: baseColors.semantic.danger.dark[9],
      hover: baseColors.semantic.danger.dark[10],
      muted: baseColors.semantic.danger.dark[4],
      mutedHover: baseColors.semantic.danger.dark[5],
    },
    warning: {
      default: baseColors.semantic.warning.dark[9],
      hover: baseColors.semantic.warning.dark[11],
      muted: baseColors.semantic.warning.dark[4],
      mutedHover: baseColors.semantic.warning.dark[5],
    },
    info: {
      default: baseColors.semantic.info.dark[9],
      hover: baseColors.semantic.info.dark[11],
      muted: baseColors.semantic.info.dark[4],
      mutedHover: baseColors.semantic.info.dark[5],
    },
    ai: {
      default: baseColors.utility.iris.dark[9],
      muted: baseColors.utility.iris.dark[3],
      mutedHover: baseColors.utility.iris.dark[4],
      strongest: baseColors.utility.iris.dark[11],
    },
    utility: {
      bronze: {
        default: baseColors.utility.bronze.dark[9],
        muted: baseColors.utility.bronze.dark[3],
        mutedHover: baseColors.utility.bronze.dark[4],
      },
      gold: {
        default: baseColors.utility.gold.dark[9],
        muted: baseColors.utility.gold.dark[3],
        mutedHover: baseColors.utility.gold.dark[4],
      },
      plum: {
        default: baseColors.utility.plum.dark[9],
        muted: baseColors.utility.plum.dark[3],
        mutedHover: baseColors.utility.plum.dark[4],
      },
      pink: {
        default: baseColors.utility.pink.dark[9],
        muted: baseColors.utility.pink.dark[3],
        mutedHover: baseColors.utility.pink.dark[4],
      },
      orange: {
        default: baseColors.utility.orange.dark[9],
        muted: baseColors.utility.orange.dark[3],
        mutedHover: baseColors.utility.orange.dark[4],
      },
      lime: {
        default: baseColors.utility.lime.dark[9],
        muted: baseColors.utility.lime.dark[3],
        mutedHover: baseColors.utility.lime.dark[4],
      },
      mint: {
        default: baseColors.utility.mint.dark[9],
        muted: baseColors.utility.mint.dark[3],
        mutedHover: baseColors.utility.mint.dark[4],
      },
      iris: {
        default: baseColors.utility.iris.dark[9],
        muted: baseColors.utility.iris.dark[3],
        mutedHover: baseColors.utility.iris.dark[4],
      },
    },
  },
  fg: {
    default: baseColors.neutrals.dark[12],
    muted: baseColors.neutrals.dark[11],
    subtle: baseColors.neutrals.dark[9],
    inverted: baseColors.neutrals.dark[1],
    elevated: baseColors.neutrals.dark[5],
    brand: {
      default: baseColors.brand.dark[9],
      onBrand: baseColors.brand.dark[1],
      onBrandMuted: baseColors.brand.dark[11],
    },
    danger: {
      default: baseColors.semantic.danger.dark[9],
      onDanger: baseColors.white,
      onDangerMuted: baseColors.semantic.danger.dark[12],
    },
    warning: {
      default: baseColors.semantic.warning.dark[11],
      onWarning: baseColors.semantic.warning.dark[1],
      onWarningMuted: baseColors.semantic.warning.dark[12],
    },
    success: {
      default: baseColors.semantic.success.dark[9],
      onSuccess: baseColors.white,
      onSuccessMuted: baseColors.semantic.success.dark[12],
    },
    info: {
      default: baseColors.semantic.info.dark[9],
      onInfo: baseColors.white,
      onInfoMuted: baseColors.semantic.info.dark[12],
    },
    ai: {
      default: baseColors.utility.iris.dark[9],
      strongest: baseColors.utility.iris.dark[11],
    },
    utility: {
      bronze: { default: baseColors.utility.bronze.dark[9] },
      gold: { default: baseColors.utility.gold.dark[9] },
      plum: { default: baseColors.utility.plum.dark[9], 'on-plum-muted': baseColors.utility.plum.dark[12] },
      pink: { default: baseColors.utility.pink.dark[12] },
      orange: { default: baseColors.utility.orange.dark[9] },
      lime: { default: baseColors.utility.lime.dark[9] },
      mint: { default: baseColors.utility.mint.dark[12] },
    },
  },
  text: {
    default: baseColors.neutrals.dark[12],
    muted: baseColors.neutrals.dark[11],
    subtle: baseColors.neutrals.dark[9],
    inverted: baseColors.neutrals.dark[1],
    link: baseColors.semantic.info.dark[11],
    slate: baseColors.brandSlate.dark,
    brand: {
      default: baseColors.brand.dark[11],
      onBrand: baseColors.brand.dark[1],
      onBrandMuted: baseColors.brand.dark[12],
    },
    success: {
      default: baseColors.semantic.success.dark[11],
      onSuccess: baseColors.white,
      onSuccessMuted: baseColors.semantic.success.dark[12],
    },
    danger: {
      default: baseColors.semantic.danger.dark[11],
      onDanger: baseColors.white,
      onDangerMuted: baseColors.semantic.danger.dark[12],
    },
    warning: {
      default: baseColors.semantic.warning.dark[11],
      onWarning: baseColors.semantic.warning.dark[1],
      onWarningMuted: baseColors.semantic.warning.dark[12],
    },
    info: {
      default: baseColors.semantic.info.dark[11],
      onInfo: baseColors.white,
      onInfoMuted: baseColors.semantic.info.dark[12],
    },
    ai: {
      default: baseColors.utility.iris.dark[11],
      onAi: baseColors.white,
    },
    utility: {
      bronze: { default: baseColors.utility.bronze.dark[12], 'on-bronze': baseColors.white },
      gold: { default: baseColors.utility.gold.dark[12], 'on-gold': baseColors.white },
      plum: { default: baseColors.utility.plum.dark[12], 'on-plum': baseColors.white },
      pink: { default: baseColors.utility.pink.dark[12], 'on-pink': baseColors.white },
      orange: { default: baseColors.utility.orange.dark[12], 'on-orange': baseColors.white },
      lime: { default: baseColors.utility.lime.dark[12], 'on-lime': baseColors.utility.lime.dark[3] },
      mint: { default: baseColors.utility.mint.dark[12], 'on-mint': baseColors.utility.mint.dark[3] },
    },
  },
  border: {
    subtle: baseColors.neutrals.dark[7],
    glass: baseColors.transparent.white[8],
    strong: baseColors.neutrals.dark[9],
    strongest: baseColors.neutrals.dark[11],
    focus: baseColors.semantic.info.dark[9],
    white: baseColors.white,
    inverted: baseColors.white,
    transparent: baseColors.transparent.white[48],
    transparent_inverted: baseColors.transparent.black[48],
    brand: {
      subtle: baseColors.brand.dark[6],
      strong: baseColors.brand.dark[9],
      strongest: baseColors.brand.dark[11],
    },
    success: {
      strong: baseColors.semantic.success.dark[9],
      focus: baseColors.semantic.success.dark[7],
      subtle: baseColors.semantic.success.dark[6],
      strongest: baseColors.semantic.success.dark[11],
    },
    danger: {
      strong: baseColors.semantic.danger.dark[9],
      focus: baseColors.semantic.danger.dark[7],
      subtle: baseColors.semantic.danger.dark[6],
      strongest: baseColors.semantic.danger.dark[11],
    },
    warning: {
      strong: baseColors.semantic.warning.dark[9],
      focus: baseColors.semantic.warning.dark[7],
      subtle: baseColors.semantic.warning.dark[6],
    },
    info: {
      strong: baseColors.semantic.info.dark[9],
      focus: baseColors.semantic.info.dark[7],
      subtle: baseColors.semantic.info.dark[6],
      strongest: baseColors.semantic.info.dark[11],
    },
    ai: {
      subtle: baseColors.utility.iris.dark[6],
      strong: baseColors.utility.iris.dark[9],
      strongest: baseColors.utility.iris.dark[12],
    },
    utility: {
      bronze: { muted: baseColors.utility.bronze.dark[6], strong: baseColors.utility.bronze.dark[9] },
      gold: { muted: baseColors.utility.gold.dark[6], strong: baseColors.utility.gold.dark[9] },
      plum: {
        muted: baseColors.utility.plum.dark[6],
        strong: baseColors.utility.plum.dark[9],
        strongest: baseColors.utility.plum.dark[12],
      },
      pink: { muted: baseColors.utility.pink.dark[6], strong: baseColors.utility.pink.dark[9] },
      orange: { muted: baseColors.utility.orange.dark[6], strong: baseColors.utility.orange.dark[9] },
      lime: { muted: baseColors.utility.lime.dark[6], strong: baseColors.utility.lime.dark[9] },
      mint: { muted: baseColors.utility.mint.dark[6], strong: baseColors.utility.mint.dark[9] },
      iris: { muted: baseColors.utility.iris.dark[6], strong: baseColors.utility.iris.dark[9] },
    },
  },
  effects: {
    'active-focus': baseColors.transparent.white[16],
    'active-ai': baseColors.utility.iris.dark[4],
    'active-error': baseColors.semantic.danger.dark[4],
    'active-success': baseColors.semantic.success.dark[4],
    'active-brand': baseColors.brand.dark[3],
    'button-inner': baseColors.transparent.white[8],
    glass: baseColors.transparent.white[24],
    'button-drop': baseColors.transparent.black[8],
  },
  shadows: {
    xs: { 1: 'rgba(0, 0, 0, 0.3)' },
    sm: { 1: 'rgba(0, 0, 0, 0.32)', 2: 'rgba(0, 0, 0, 0.36)' },
    md: { 1: 'rgba(0, 0, 0, 0.4)', 2: 'rgba(0, 0, 0, 0.4)' },
    lg: { 1: 'rgba(0, 0, 0, 0.45)', 2: 'rgba(0, 0, 0, 0.44)' },
    xl: { 1: 'rgba(0, 0, 0, 0.55)', 2: 'rgba(0, 0, 0, 0.5)' },
  },
  dataViz: baseColors.dataViz.dark,
} as const
